<template>
	<div class="equip-status-bar flex-center">
		<div class="bar-wrp">
			<div :id="chartId" style="height: 30px;width: 280px;"></div>
		</div>
	</div>
</template>

<script>
import { debounce } from '@/utils/common'

export default {
	name: 'StackBar',
	props: {
		random: {
			type: [Number, String],
			default: 0
		},

		list: {
			type: Array,
			default () {
				return []
			}
		},

		show: {
			type: [Number, Boolean],
			default: true
		},
	},

	data () {
		return {
			unit: '',
			chart: null,
			chartOption: {
				tooltip: {
					show: false
				},
				grid: {
					top: 0,
					bottom: 2,
					right: 0,
					left: 0
				},
				xAxis: {
					type: 'value',
					axisTick: {
						show: false
					},
					axisLine: {
						show: false
					}
				},
				yAxis: {
					type: 'category',
					show: false,
					data: ['status']
				},
				series: [
				],
				animation: false
			}
		}
	},

	computed: {
		chartId () {
			return `status-bar-${this.random}`
		}
	},

	watch: {
		random: function (newVal, oval) {
			if (this.show) {
				this.fetchData()
			} else {
				this.disposeChart()
			}
		}
	},

	created: function () {
		this.fetchData()
	},

	mounted () {
		this.initChart()
		this.__resizeHandler = debounce(() => {
			if (this.chart) {
				this.chart.resize()
			}
		}, 100)
		window.addEventListener('resize', this.__resizeHandler)
	},

	beforeDestroy () {
		this.disposeChart()
		window.removeEventListener('resize', this.__resizeHandler)
	},

	methods: {
		fetchData () {
			let arr = []
			if (this.list.length) {
				this.list.forEach(item => {
					let temp = {
						type: 'bar',
						stack: 'status',
						label: {
							show: false
						},
						itemStyle: {
							color: '#999'
						},
						data: [item.duration]
					}
					if (item.status == 2) temp.itemStyle.color = '#E6A23C'
					if (item.status == 3) temp.itemStyle.color = '#07c160'
					if (item.status == 4) temp.itemStyle.color = '#ff776c'
					arr.push(temp)
				})
				this.chartOption.series = arr
				if (this.chart) {
					this.chart.setOption(this.chartOption)
				}
			}


		},

		initChart () {
			this.chart = this.$echarts.init(document.getElementById(this.chartId), 'teenager')
			this.chart.setOption(this.chartOption)
		},

		disposeChart () {
			if (this.chart) {
				this.chart.dispose()
				this.chart = undefined
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.equip-status-bar {
	position: relative;
	.curve-wrp {
		position: absolute;
		bottom: 23px;
		left: 0;
		right: 0;
		width: 100%;
	}
}
</style>
